// extracted by mini-css-extract-plugin
export var TeamCard = "index-module--TeamCard--2cf9f";
export var TeamCardImage = "index-module--TeamCardImage--0bcaa";
export var TeamCardWrap = "index-module--TeamCardWrap--8e2f0";
export var TeamCardWrapLine = "index-module--TeamCardWrapLine--39246";
export var region = "index-module--region--71038";